import { map } from 'lodash'
var _ = require('underscore');

const LOAD = 'server-sts/supervision/LOAD';
const LOAD_SUCCESS = 'server-sts/supervision/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/supervision/LOAD_FAIL';
const EDIT_START = 'server-sts/supervision/EDIT_START';
const EDIT_STOP = 'server-sts/supervision/EDIT_STOP';
const SAVE = 'server-sts/supervision/SAVE';
const SAVE_SUCCESS = 'server-sts/supervision/SAVE_SUCCESS';
const SAVE_FAIL = 'server-sts/supervision/SAVE_FAIL';
const CREATE = 'server-sts/supervision/CREATE';
const CREATE_SUCCESS = 'server-sts/supervision/CREATE_SUCCESS';
const CREATE_FAIL = 'server-sts/supervision/CREATE_FAIL';
const RESET_FORM = 'server-sts/supervision/RESET_FORM';

const DELETE = 'server-sts/supervision/DELETE';
const DELETE_SUCCESS = 'server-sts/supervision/DELETE_SUCCESS';
const DELETE_FAIL = 'server-sts/supervision/DELETE_FAIL';

const SORT_COLUMN = 'server-sts/supervision/SORT_COLUMN';
const SORT_COLUMN_SUCCESS = 'server-sts/supervision/SORT_COLUMN_SUCCESS';
const SORT_COLUMN_FAIL = 'server-sts/supervision/SORT_COLUMN_FAIL';
const RESET_COLUMN_SORT = 'server-sts/supervision/RESET_COLUMN_SORT';

const FILTER = 'server-sts/supervision/FILTER';
const FILTER_SUCCESS = 'server-sts/supervision/FILTER_SUCCESS';
const FILTER_FAIL = 'server-sts/supervision/FILTER_FAIL';


const EXPORT_CSV = 'server-sts/supervision/EXPORT_CSV';
const EXPORT_CSV_SUCCESS = 'server-sts/supervision/EXPORT_CSV_SUCCESS';
const EXPORT_CSV_FAIL = 'server-sts/supervision/EXPORT_CSV_FAIL';

const DISPLAY_ANOMALIES = 'server-sts/supervision/DISPLAY_ANOMALIES';

const RESET_FILTER = 'server-sts/supervision/RESET_FILTER';



const UNMOUNT = 'server-sts/supervision/UNMOUNT';





// redux-persist gère la persistance automatiquement via reducer.js

const initialState = {
  loaded: false,
  loading: false,
  created: false,
  supervisionCreatedError: false,
  editing: {},
  saveError: {},
  saveSuccess: false,
  currentPage: 1,
  sorting: { columns: {} },
  filter: {},
  data: {},
  pristineData: [],
  csv_data: [],
  ids: [],
  addresses: [],
  numsAsc: [],
  displayAnomaliesBOOL: false,
  callTypes: [],
  anomalies: [],

  allRows:[],

  mainLoading:false,

  filterOpened: false,

  options: {
    filter: {},
    pagination: { page: 1, perPage: 10 }
  },
  rangeNumber:5000
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {



    case 'OPEN_FILTER':

      return {
        ...state,
        filterOpened: !state.filterOpened
      };


    case 'STORE_OPTIONS':

      var { options } = action
      return {
        ...state,
        options: {
          ...state.options,
          ...options
        }
      };


    case DISPLAY_ANOMALIES:
      return {
        ...state,
        displayAnomaliesBOOL: !state.displayAnomaliesBOOL,
      };


    case SORT_COLUMN:

      return {
        ...state,
        loading: true,
        sorting: {
          columns: {
            ...state.sorting.columns,
            [action.obj.column]: action.obj.direction
          }
        }
      };
    case SORT_COLUMN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.result.rows,
        sorting: {
          columns: {
            ...state.sorting.columns,
          }
        }
      };
    case SORT_COLUMN_FAIL: 
      return {
        ...state,
        loading: false,
        sorting: {
          columns: {
            ...state.sorting.columns,
          }
        }
      };
 
    case RESET_COLUMN_SORT:
      return {
        ...state,
        loading: false,
        sorting: {
          columns: {}
        }
      };
    
    case 'RESET_FILTER_FORCE':
      return {
        ...state,
        filter:{},
        filterOpened: false
      };

    case RESET_FILTER:

      if ('pid' in state.filter) {
        var filter = {
          pid: state.filter.pid,
          idList: state.filter.idList.filter(i => i.value == state.filter.pid)
        }
      } else {
        var filter = {}
      }


      return {
        ...state,
        filter
      };

    case LOAD:
      return {
        ...state,
        loading: true,
        currentPage: action.page,
        chunked: action.chunked,
        loadType:'load'
      };


    case LOAD_SUCCESS:
      /*if (!state.pristineData) {
        var pristineData = action.result.pristineRows;
      } else {
        var pristineData = state.pristineData;
      }*/

      const {
        currentPage,
        supervisionNb,
        ids,
        addresses,
        numsAsc,
        callTypes,
        orphans,
        anomalies,
        offset
      } = action.result



      var data = {
          ...state.data,
          [action.result.offset]: action.result.rows
      }

      var loading = !state.chunked ? false : Object.keys(data).length < state.chunked

      var allRows = []
      for (const key in data) {
        const value = data[key];
        allRows = [...allRows, ...value]
      }


      return {
        ...state,
        loading,
        loaded: true,
        data,                 
        currentPage,
        supervisionNb,
        error: null,
        ids:ids,
        addresses,
        numsAsc,
        callTypes,
        orphans,
        anomalies,
        offset,
        allRows
      };

    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      };

    case EDIT_START:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: true
        }
      };

    case EDIT_STOP:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: false
        },
        saveSuccess: false,
        saveError: {
          ...state.saveError,
          [action.id]: null,
        }
      };

    case FILTER: {

      const { columns, filter } = action
      const newFilter = { ...state.filter, ...filter };

      return {
        ...state,
        loading: true,
        columns,
        filter: newFilter,
        filterOpened: true,
        loadType:'filter'
      };
    }

    case FILTER_SUCCESS:

      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        data: {
          ...state.data,
          [action.result.offset]: action.result.rows
        },
        
        //...action.result
        currentPage: action.result.currentPage,
        supervisionNb: action.result.supervisionNb,
        pages: action.result.pages,
        ids: action.result.ids,
        addresses: action.result.addresses,
        numsAsc: action.result.numsAsc,
        callTypes: action.result.callTypes,
        orphans: action.result.orphans,
        anomalies: action.result.anomalies,
        

      };
    
    
    case 'RESET_DATA':
      return {
        ...state,

        data: {},
       
      };

    case FILTER_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      };


    case CREATE:
      return {
        ...state,
        loading: true
      };

    case CREATE_SUCCESS:
      return {
        ...state,
        data: action.result.supervision,
        currentPage: action.result.currentPage,
        supervisionNb: action.result.supervisionNb,
        pages: action.result.pages,
        created: true,
        loading: false,
        supervisionCreatedError: false,
      };

    case CREATE_FAIL:
      return {
        ...state,
        created: false,
        loading: false,
        supervisionCreatedError: action.error,
      };


    case DELETE:
      return {
        ...state,
        loading: true
      };

    case DELETE_SUCCESS:
      return {
        ...state,
        data: action.result.supervision,
        currentPage: action.result.currentPage,
        supervisionNb: action.result.supervisionNb,
        pages: action.result.pages,
        created: true,
        loading: false,
        supervisionCreatedError: false,
      };

    case DELETE_FAIL:
      return {
        ...state,
        created: false,
        loading: false,
        supervisionCreatedError: action.error,
      };


    case RESET_FORM:
      return {
        ...state,
        created: false,
        loading: false,
        supervisionCreatedError: false,
      };
    case SAVE:
      return state; // 'saving' flag handled by redux-form
    case SAVE_SUCCESS:
      return {
        data: action.result.obj.supervision,
        currentPage: action.result.obj.currentPage,
        supervisionNb: action.result.obj.supervisionNb,
        pages: action.result.obj.pages,
        editing: {
          ...state.editing,
          [action.result.id]: true
        },
        saveError: {
          ...state.saveError,
          [action.result.id]: null
        },
        saveSuccess: true,
        saveErrors: false
      };
    case SAVE_FAIL:
      return typeof action.error === 'string' ? {
        ...state,
        saveError: {
          ...state.saveError,
          [action.id]: action.error
        },
        saveSuccess: false,
      } : state;


    case UNMOUNT:
      return {
        ...state,
        data: [],
        pristineData: [],
        //filter: {},
        loaded: false
      };



    case EXPORT_CSV:
      return {
        ...state,
        csv_loading: true,
      };

    case EXPORT_CSV_SUCCESS:
      return {
        ...state,
        csv_success: true,
        csv_error: false,
        csv_loading: false,
        csv_data: action.result,
      };

    case EXPORT_CSV_FAIL:
      return {
        ...state,
        csv_success: false,
        csv_error: true,
        csv_loading: false
      };
    
    case 'RESTORE_ROWS':

      return {
        ...state,
        rows:action.rows
      }
    
      
    
    
    case 'MAIN_LOADING':

      return {
        ...state,
        mainLoading:action.loading
      }
    
    
    /*case 'SAVE_ROWS':

      return {
        ...state,
        rows:action.rows
      }*/



    default:
      return state;
  }
}


export function restoreSupervisionRows(rows) {
  return { type: 'RESTORE_ROWS', rows };
  
}


export function isLoaded(globalState) {
  return globalState.supervision && globalState.supervision.loaded;
}


export function createFiche(values) {
  if (values.localisation_adresse != null) {
    if (typeof values.localisation_adresse === 'object') {
      values.localisation_adresse = values.localisation_adresse.label;
    }
  }

  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (supervision) => supervision.post('/supervision/create', {
      data: {
        values
      }
    })
  };
}

export function load(page, params, columns, filter = null, offset = 0, chunked = false) {

  return {
    promise: (client) => client.post('/supervision/load', { data: { page, params, columns, filter, offset } }),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    page,
    chunked
  };
}

export function changeFilter(page = 1, filter, params, columns, offset=0) {
  return {
    promise: (client) => client.post('/supervision/load', { data: { params, filter, page, columns, offset }  }),
    types: [FILTER, FILTER_SUCCESS, FILTER_FAIL], filter, columns
  };
}

export function sortColumn(page = 1, obj, params) {
  var columns = { [obj.column]: obj.direction }
  return {
    promise: (supervision) => supervision.post('/supervision/load', { data: { params, columns, page } }),
    types: [SORT_COLUMN, SORT_COLUMN_SUCCESS, SORT_COLUMN_FAIL], obj
  };
}

export function save(values, fields) {
  if (values.localisation_adresse != null) {
    if (typeof values.localisation_adresse === 'object') {
      values.localisation_adresse = values.localisation_adresse.label;
    }
  }

  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: values.id,
    promise: (client) => client.post('/supervision/update', {
      data: { ...values, gsm_dirty: fields.identification_GSM.dirty },
    })
  };
}

export function deleteFiche(id) {
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    promise: (supervision) => supervision.post('/supervision/deleteFiche', {
      data: { id }
    })
  };
}


export function exportCSV(params, filter, columns, supervisionNb, offset) {
  return {
    types: [EXPORT_CSV, EXPORT_CSV_SUCCESS, EXPORT_CSV_FAIL],
    promise: (supervision) => supervision.post('/supervision/exportCSV', {
      data: { params, filter, columns, supervisionNb, offset }
    })
  };
}


export function storeOptions(options) {
  return { type: 'STORE_OPTIONS', options };
}

export function resetSupervisionData() {
  return { type: 'RESET_DATA'};
}


export function activateMainLoading(loading) {
  return { type: 'MAIN_LOADING', loading };
}



export function displayAnomalies() {
  return { type: DISPLAY_ANOMALIES };
}

export function resetFormCs() {
  return { type: RESET_FORM };
}


export function unmount() {
  return { type: UNMOUNT };
}

export function editStart(id) {
  return { type: EDIT_START, id };
}

export function editStop(id) {
  return { type: EDIT_STOP, id };
}

export function resetColumnSort() {
  return { type: RESET_COLUMN_SORT };
}

export function resetFilter() {
  return { type: RESET_FILTER };
}


export function resetFilterForce() {
  return { type: 'RESET_FILTER_FORCE' };
}


export function openFilter() {
  return { type: 'OPEN_FILTER' };
}

